<template>
  <div class="n-input" :class="{ 'has-error': errorMessage }">
    <label :for="inputId" :class="{ 'sr-only': hideLabel }">{{ label }}</label>
    <input
      class="control"
      type="number"
      :value="value"
      :id="inputId"
      :name="name"
      :disabled="disabled"
      :placeholder="placeholder"
      :min="min"
      :max="max"
      :step="step"
      @input="handleInput($event)"
      @change="emit('change', value)"
    />
    <span v-if="errorMessage" class="error-message">{{ errorMessage }}</span>
  </div>
</template>
<script lang="ts" setup>
import { useIdGenerator } from '@/shared/designsystem/useIdGenerator';
import { useVModel } from '@vueuse/core';

defineOptions({
  name: 'n-number-input',
});

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  label: {
    type: String,
  },
  name: {
    type: String,
  },
  modelValue: {
    type: Number,
    required: true,
  },
  placeholder: {
    type: String,
  },
  min: {
    type: Number,
  },
  max: {
    type: Number,
  },
  step: {
    type: Number,
  },
  errorMessage: {
    type: String,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  hideLabel: {
    type: String,
  },
});

const { inputId } = useIdGenerator(props.id);

const emit = defineEmits<{
  (e: 'update:modelValue', value: number): void;
  (e: 'change', value: number): void;
}>();

const value = useVModel(props, 'modelValue', emit);

const handleInput = (event: Event) => {
  const input = event.target as HTMLInputElement;
  value.value = input.value === '' ? (props.min ?? 0) : Number(input.value);
};
</script>

<style lang="scss" scoped>
@use '../../../styles/accessibility' as *;
@use '../../../styles/colours' as *;
@use '../../../styles/input' as *;
</style>
